export default __webpack_public_path__ + "static/media/dirt.11c5b116.png";